import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/pages/dashboard.vue'),
    meta: {
      menu: 'Dashboard'
    }
  },
  {
    path: '/dashboardCalendar',
    name: 'Calendar',
    component: () => import('@/pages/dashboard-calendar.vue')
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('@/pages/signin.vue')
  },
  {
    path: '/lifeinsurecases',
    name: 'LifeInsureCaseList',
    component: () => import('@/pages/life-insures-list.vue')
  },
  {
    path: '/lifeinsurecase/:id',
    name: 'LifeInsureCaseDetail',
    component: () => import('@/pages/life-insure-detail.vue'),
    meta: {
      menu: 'LifeInsureCaseList'
    }
  },
  {
    path: '/tickets/dashboard',
    name: 'TicketDashborad',
    component: () => import('@/pages/tickets-dashboard.vue')
  },
  {
    path: '/tickets/:type',
    name: 'TicketList',
    component: () => import('@/pages/tickets-list.vue'),
    meta: {
      menu: 'TicketDashborad'
    }
  },
  {
    path: '/ticket/new',
    name: 'TicketNew',
    component: () => import('@/pages/ticket-create.vue'),
    meta: {
      menu: 'TicketDashborad'
    }
  },
  {
    path: '/ticket/:id',
    name: 'TicketDetail',
    component: () => import('@/pages/ticket-detail.vue'),
    meta: {
      menu: 'TicketDashborad'
    }
  },
  {
    path: '/users',
    name: 'UserList',
    component: () => import('@/pages/users-list.vue')
  },
  {
    path: '/password',
    name: 'ChangePassword',
    component: () => import('@/pages/change-password.vue')
  },
  {
    path: '/labels/:type',
    name: 'LabelListType',
    component: () => import('@/pages/labels-list.vue')
  },
  {
    path: '/labels',
    name: 'LabelList',
    component: () => import('@/pages/labels-list.vue')
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('@/pages/messages-list.vue')
  },
  {
    path: '/policyReports',
    name: 'PolicyReports',
    component: () => import('@/pages/policy-reports.vue')
  },
  {
    path: '/reportsRules',
    name: 'ReportsRules',
    component: () => import('@/pages/reports-rules.vue')
  },
  {
    path: '/downloadReports/:type',
    name: 'DownloadReports',
    component: () => import('@/pages/download-reports.vue'),
    meta: {
      menu: ''
    }
  },
  {
    path: '/statisticAnalysis',
    name: 'StatisticAnalysis',
    component: () => import('@/pages/statistic-analysis.vue')
  },
  {
    path: '/accounts',
    name: 'AccountsList',
    component: () => import('@/pages/accounts-list.vue')
  },
  {
    path: '/globalAccounts/:search',
    name: 'AccountsListWithSearchval',
    component: () => import('@/pages/accounts-list-from-dashboard.vue'),
    meta: {
      menu: 'AccountsList'
    }
  },
  {
    path: '/accounts/cases',
    name: 'AccountsWithCases',
    component: () => import('@/pages/accounts-with-cases.vue')
  },
  {
    path: '/account/:id',
    name: 'AccountDetail',
    component: () => import('@/pages/account-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'AccountDetailDetail',
        component: () => import('@/modules/Account/views/detail.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'contact',
        name: 'AccountDetailContact',
        component: () => import('@/modules/Account/views/contact.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'case',
        name: 'AccountDetailCase',
        component: () => import('@/modules/Account/views/case.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'quote',
        name: 'AccountDetailQuotes',
        component: () => import('@/modules/Account/views/quote.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'policy',
        name: 'AccountDetailPolicy',
        component: () => import('@/modules/Account/views/policy.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'source',
        name: 'AccountDetailSource',
        component: () => import('@/modules/Account/views/source.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'document',
        name: 'AccountDetailDocument',
        component: () => import('@/modules/Account/views/document.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'additional',
        name: 'AccountDetailAdditional',
        component: () => import('@/modules/Account/views/additional.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'certificate',
        name: 'AccountDetailCertificate',
        component: () => import('@/modules/Account/views/certificate.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'claim',
        name: 'AccountDetailClaim',
        component: () => import('@/modules/Account/views/claim.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'assets',
        name: 'AccountDetailAssets',
        component: () => import('@/modules/Account/views/asset.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'accountCertificate',
        name: 'AccountDetailCertificates',
        component: () => import('@/modules/Account/views/account-certificate.vue'),
        meta: {
          menu: 'AccountsList'
        }
      }
    ]
  },
  {
    path: '/property/:id',
    name: 'AccountAssetPropertyDetail',
    component: () => import('@/pages/account-asset-property-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'AccountAssetPropertyDetailDetail',
        component: () => import('@/modules/AccountAsset/views/property-detail.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'document',
        name: 'AccountAssetPropertyDetailDocument',
        component: () => import('@/modules/AccountAsset/views/document.vue'),
        meta: {
          menu: 'AccountsList'
        }
      }
    ]
  },
  {
    path: '/vehicle/:id',
    name: 'AccountAssetVehicleDetail',
    component: () => import('@/pages/account-asset-vehicle-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'AccountAssetVehicleDetailDetail',
        component: () => import('@/modules/AccountAsset/views/vehicle-detail.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'document',
        name: 'AccountAssetVehicleDetailDocument',
        component: () => import('@/modules/AccountAsset/views/document.vue'),
        meta: {
          menu: 'AccountsList'
        }
      }
    ]
  },
  {
    path: '/accountCertificate/:id',
    name: 'AccountCertificateDetail',
    component: () => import('@/pages/account-certificate-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'AccountCertificateDetailDetail',
        component: () => import('@/modules/AccountCertificate/views/detail.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'document',
        name: 'AccountCertificateDetailDocument',
        component: () => import('@/modules/AccountCertificate/views/document.vue'),
        meta: {
          menu: 'AccountsList'
        }
      }
    ]
  },
  {
    path: '/certificate/:id',
    name: 'CertificateDetail',
    component: () => import('@/pages/certificate-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'CertificateOfInsuranceDetailDetail',
        component: () => import('@/modules/CertificateOfInsurance/views/detail.vue'),
        meta: {
          menu: 'AccountsList'
        }
      },
      {
        path: 'acordForms',
        name: 'CertificateOfInsuranceDetailAcord',
        component: () => import('@/modules/CertificateOfInsurance/views/acord.vue'),
        meta: {
          menu: 'AccountsList'
        }
      }
    ]
  },
  {
    path: '/account/quotes/:id',
    name: 'AccountRelatedQuotesList',
    component: () => import('@/pages/related-quotes-list.vue'),
    meta: {
      menu: 'AccountsList'
    }
  },
  {
    path: '/account/policylist/:id',
    name: 'AccountRelatedPoliciesList',
    component: () => import('@/pages/related-policies-list.vue'),
    meta: {
      menu: 'AccountsList'
    }
  },
  {
    path: '/contacts/:id',
    name: 'ContactAllList',
    component: () => import('@/pages/contacts-list.vue'),
    meta: {
      menu: 'ContactList'
    }
  },
  {
    path: '/contacts',
    name: 'ContactList',
    component: () => import('@/pages/contacts-list.vue')
  },
  {
    path: '/globalContacts/:type/:search',
    name: 'ContactListWithSearchval',
    component: () => import('@/pages/contacts-list-from-dashboard.vue'),
    meta: {
      menu: 'ContactList'
    }
  },
  {
    path: '/contact/:id',
    name: 'ContactDetail',
    component: () => import('@/pages/contact-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'ContactDetailDetail',
        component: () => import('@/modules/Contact/views/detail.vue'),
        meta: {
          menu: 'ContactList'
        }
      },
      {
        path: 'account',
        name: 'ContactDetailAccount',
        component: () => import('@/modules/Contact/views/account.vue'),
        meta: {
          menu: 'ContactList'
        }
      },
      {
        path: 'policy',
        name: 'ContactDetailPolicy',
        component: () => import('@/modules/Contact/views/policy.vue'),
        meta: {
          menu: 'ContactList'
        }
      },
      {
        path: 'quote',
        name: 'ContactDetailQuotes',
        component: () => import('@/modules/Contact/views/quote.vue'),
        meta: {
          menu: 'ContactList'
        }
      },
      {
        path: 'document',
        name: 'ContactDetailDocument',
        component: () => import('@/modules/Contact/views/document.vue'),
        meta: {
          menu: 'ContactList'
        }
      },
      {
        path: 'additional',
        name: 'ContactDetailAdditional',
        component: () => import('@/modules/Contact/views/additional.vue'),
        meta: {
          menu: 'ContactsList'
        }
      }
    ]
  },
  {
    path: '/accounts/:id/:type',
    name: 'AccountAllList',
    component: () => import('@/pages/accounts-list.vue'),
    meta: {
      menu: 'ContactList'
    }
  },
  {
    path: '/contact/policylist/:id',
    name: 'ContactRelatedPoliciesList',
    component: () => import('@/pages/related-policies-list.vue'),
    meta: {
      menu: 'ContactList'
    }
  },
  {
    path: '/contact/quotes/:id',
    name: 'ContactRelatedQuotesList',
    component: () => import('@/pages/related-quotes-list.vue'),
    meta: {
      menu: 'ContactList'
    }
  },
  {
    path: '/policies',
    name: 'PoliciesList',
    component: () => import('@/pages/policies-list.vue')
  },
  {
    path: '/globalPolicies/:search',
    name: 'PoliciesListWithSearchval',
    component: () => import('@/pages/policies-list-from-dashboard.vue'),
    meta: {
      menu: 'PoliciesList'
    }
  },
  {
    path: '/policies/source',
    name: 'PoliciesSourceList',
    component: () => import('@/pages/policies-source-list.vue')
  },
  {
    path: '/envelope/:id/:masterType/:masterId',
    name: 'EnvelopDetail',
    component: () => import('@/pages/envelop-detail.vue'),
    meta: {
      menu: 'PoliciesList'
    }
  },
  {
    path: '/policy/:id',
    name: 'PolicyDetail',
    component: () => import('@/pages/policy-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'PolicyDetailDetail',
        component: () => import('@/modules/Policy/views/detail.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'related',
        name: 'PolicyDetailRelated',
        component: () => import('@/modules/Policy/views/related.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'ACORD Form',
        name: 'PolicyAcordForm',
        component: () => import('@/modules/Policy/views/acordForm.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'history',
        name: 'PolicyDetailHistory',
        component: () => import('@/modules/Policy/views/history.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'collection',
        name: 'PolicyDetailCollection',
        component: () => import('@/modules/Policy/views/collection.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'source',
        name: 'PolicyDetailSource',
        component: () => import('@/modules/Policy/views/source.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'addtional',
        name: 'PolicyDetailAdditional',
        component: () => import('@/modules/Policy/views/additional.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'endorsement',
        name: 'PolicyDetailEndorsement',
        component: () => import('@/modules/Policy/views/endorsement.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'docusign',
        name: 'PolicyDetailDocuSign',
        component: () => import('@/modules/Policy/views/docuSign.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      },
      {
        path: 'claim',
        name: 'PolicyDetailClaim',
        component: () => import('@/modules/Policy/views/claim.vue'),
        meta: {
          menu: 'PoliciesList'
        }
      }
    ]
  },
  {
    path: '/policy/vehiclelist/:policyId',
    name: 'PolicyVehicleAllList',
    component: () => import('@/pages/vehicles-list.vue'),
    meta: {
      menu: 'PoliciesList'
    }
  },
  {
    path: '/policy/insuredlist/:policyId',
    name: 'PolicyInsuredAllList',
    component: () => import('@/pages/insureds-list.vue'),
    meta: {
      menu: 'PoliciesList'
    }
  },
  {
    path: '/policy/propertylist/:id',
    name: 'PolicyPropertyAllList',
    component: () => import('@/pages/properties-list.vue'),
    meta: {
      menu: 'PoliciesList'
    }
  },
  {
    path: '/quote/vehiclelist/:quoteId',
    name: 'QuoteVehicleAllList',
    component: () => import('@/pages/vehicles-list.vue'),
    meta: {
      menu: 'QuotesList'
    }
  },
  {
    path: '/quote/insuredlist/:quoteId',
    name: 'QuoteInsuredAllList',
    component: () => import('@/pages/insureds-list.vue'),
    meta: {
      menu: 'QuotesList'
    }
  },
  {
    path: '/quote/propertylist/:quoteId',
    name: 'QuotePropertyAllList',
    component: () => import('@/pages/properties-list.vue'),
    meta: {
      menu: 'QuotesList'
    }
  },
  {
    path: '/relation/:id',
    name: 'AccountContactRelation',
    component: () => import('@/pages/account-contact-relation.vue'),
    children: [
      {
        path: 'detail',
        name: 'AccountContactRelationDetail',
        component: () => import('@/modules/AccountContactRelation/views/detail.vue'),
        meta: {
          menu: 'AccountsList'
        }
      }
    ]
  },
  {
    path: '/carriers',
    name: 'CarrierList',
    component: () => import('@/pages/carriers-list.vue')
  },
  {
    path: '/carrier/:id',
    name: 'CarrierDetail',
    component: () => import('@/pages/carrier-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'CarrierDetailDetail',
        component: () => import('@/modules/Carrier/views/detail.vue'),
        meta: {
          menu: 'CarrierList'
        }
      },
      {
        path: 'additional',
        name: 'CarrierDetailAdditional',
        component: () => import('@/modules/Carrier/views/additional.vue'),
        meta: {
          menu: 'CarrierList'
        }
      }
    ]
  },
  {
    path: '/carrierProduct/:id',
    name: 'CarrierProductDetail',
    component: () => import('@/pages/carrier-product-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'CarrierProductDetailDetail',
        component: () => import('@/modules/CarrierProduct/views/detail.vue'),
        meta: {
          menu: 'CarrierProductList'
        }
      },
      {
        path: 'ga',
        name: 'CarrierProductDetailCommissionGA',
        component: () => import('@/modules/CarrierProduct/views/commission.vue'),
        meta: {
          menu: 'CarrierProductList'
        }
      },
      {
        path: 'direct',
        name: 'CarrierProductDetailCommissionDirect',
        component: () => import('@/modules/CarrierProduct/views/commission.vue'),
        meta: {
          menu: 'CarrierProductList'
        }
      },
      {
        path: 'quote',
        name: 'CarrierProductDetailQuotes',
        component: () => import('@/modules/CarrierProduct/views/quote.vue'),
        meta: {
          menu: 'CarrierProductList'
        }
      }, {
        path: 'policy',
        name: 'CarrierProductDetailPolicy',
        component: () => import('@/modules/CarrierProduct/views/policy.vue'),
        meta: {
          menu: 'CarrierProductList'
        }
      },
      {
        path: 'additional',
        name: 'CarrierProductDetailAdditional',
        component: () => import('@/modules/CarrierProduct/views/additional.vue'),
        meta: {
          menu: 'CarrierProductList'
        }
      }
    ]
  },
  {
    path: '/carrierProducts',
    name: 'CarrierProductList',
    component: () => import('@/pages/carrier-products-list.vue'),
    meta: {
      menu: 'CarrierProductList'
    }
  },
  {
    path: '/allCarrierProducts',
    name: 'AllCarrierProductsList',
    component: () => import('@/pages/carrier-products-list.vue'),
    meta: {
      menu: 'CarrierProductList'
    }
  },
  {
    path: '/carrierProduct/quotes/:id',
    name: 'CarrierProductRelatedQuotesList',
    component: () => import('@/pages/related-quotes-list.vue'),
    meta: {
      menu: 'CarrierProductList'
    }
  },
  {
    path: '/carrierProduct/policylist/:id',
    name: 'CarrierProductRelatedPoliciesList',
    component: () => import('@/pages/related-policies-list.vue'),
    meta: {
      menu: 'CarrierProductList'
    }
  },
  {
    path: '/producers',
    name: 'ProducerList',
    component: () => import('@/pages/producers-list.vue')
  },
  {
    path: '/producer/:id',
    name: 'ProducerDetail',
    component: () => import('@/pages/producer-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'ProducerDetailDetail',
        component: () => import('@/modules/Producer/views/detail.vue'),
        meta: {
          menu: 'ProducerList'
        }
      },
      {
        path: 'quote',
        name: 'ProducerDetailQuotes',
        component: () => import('@/modules/Producer/views/quote.vue'),
        meta: {
          menu: 'ProducerList'
        }
      },
      {
        path: 'policy',
        name: 'ProducerDetailPolicy',
        component: () => import('@/modules/Producer/views/policy.vue'),
        meta: {
          menu: 'ProducerList'
        }
      },
      {
        path: 'additional',
        name: 'ProducerDetailAdditional',
        component: () => import('@/modules/Producer/views/additional.vue'),
        meta: {
          menu: 'ProducerList'
        }
      }
    ]
  },
  {
    path: '/producer/quotes/:id',
    name: 'ProducerRelatedQuotesList',
    component: () => import('@/pages/related-quotes-list.vue'),
    meta: {
      menu: 'ProducerList'
    }
  },
  {
    path: '/producer/policylist/:id',
    name: 'ProducerRelatedPoliciesList',
    component: () => import('@/pages/related-policies-list.vue'),
    meta: {
      menu: 'ProducerList'
    }
  },
  {
    path: '/cases/dashboard',
    name: 'CaseDashboard',
    component: () => import('@/pages/case-dashboard.vue')
  },
  {
    path: '/newcase/dashboard',
    name: 'NewcaseDashboard',
    component: () => import('@/pages/newcase-new-dashboard.vue')
  },
  {
    path: '/newcase/create',
    name: 'NewcaseCreate',
    component: () => import('@/pages/newcase-create.vue')
  },
  {
    path: '/newcase/:id/detail',
    name: 'NewcaseDetail',
    component: () => import('@/pages/newcase-detail.vue'),
    meta: {
      menu: 'NewcaseDashboard'
    }
  },
  {
    path: '/newcase/:id/create-formsite-case',
    name: 'CreateFormSiteCase',
    component: () => import('@/pages/formsite-create-case.vue'),
    meta: {
      menu: 'NewcaseDashboard'
    }
  },
  {
    path: '/cases/:type',
    name: 'CaseList',
    component: () => import('@/pages/cases-list.vue'),
    meta: {
      menu: 'CaseDashboard'
    }
  },
  {
    path: '/globalCases/:type/:search',
    name: 'CaseListWithSearchval',
    component: () => import('@/pages/cases-list-from-dashboard.vue'),
    meta: {
      menu: 'CaseDashboard'
    }
  },
  {
    path: '/case/:id',
    name: 'CaseDetail',
    component: () => import('@/pages/case-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'CaseDetailDetail',
        component: () => import('@/modules/Case/views/detail.vue'),
        meta: {
          menu: 'CaseDashboard'
        }
      },
      {
        path: 'quote',
        name: 'CaseDetailQuote',
        component: () => import('@/modules/Case/views/quote.vue'),
        meta: {
          menu: 'CaseDashboard'
        }
      },
      {
        path: 'policy',
        name: 'CaseDetailPolicy',
        component: () => import('@/modules/Case/views/policy.vue'),
        meta: {
          menu: 'CaseDashboard'
        }
      },
      {
        path: 'endorsement',
        name: 'CaseDetailEndorsement',
        component: () => import('@/modules/Case/views/endorsement.vue'),
        meta: {
          menu: 'CaseDashboard'
        }
      },
      {
        path: 'related',
        name: 'CaseDetailRelated',
        component: () => import('@/modules/Case/views/related.vue'),
        meta: {
          menu: 'CaseDashboard'
        }
      },
      {
        path: 'source',
        name: 'CaseDetailSource',
        component: () => import('@/modules/Case/views/source.vue'),
        meta: {
          menu: 'CaseDashboard'
        }
      },
      {
        path: 'attachments',
        name: 'CaseDetailAttachments',
        component: () => import('@/modules/Case/views/attachments.vue'),
        meta: {
          menu: 'CaseDashboard'
        }
      },
      {
        path: 'additional',
        name: 'CaseDetailAdditional',
        component: () => import('@/modules/Case/views/additional.vue'),
        meta: {
          menu: 'CaseList'
        }
      },
      {
        path: 'note',
        name: 'CaseDetailNote',
        component: () => import('@/modules/Case/views/note.vue'),
        meta: {
          menu: 'CaseList'
        }
      }
    ]
  },
  {
    path: '/case/quoteList/:id/:type',
    name: 'CaseRelatedQuotesList',
    component: () => import('@/pages/related-quotes-list.vue'),
    meta: {
      menu: 'CaseDashboard'
    }
  },
  {
    path: '/case/policylist/:id/:type',
    name: 'CaseRelatedPoliciesList',
    component: () => import('@/pages/related-policies-list.vue'),
    meta: {
      menu: 'CaseDashboard'
    }
  },
  {
    path: '/case/vehiclelist/:caseId',
    name: 'CaseVehicleAllList',
    component: () => import('@/pages/vehicles-list.vue'),
    meta: {
      menu: 'CaseDashboard'
    }
  },
  {
    path: '/case/propertylist/:caseId',
    name: 'CasePropertyAllList',
    component: () => import('@/pages/properties-list.vue'),
    meta: {
      menu: 'CaseDashboard'
    }
  },
  {
    path: '/case/insuredlist/:caseId',
    name: 'CaseInsuredAllList',
    component: () => import('@/pages/insureds-list.vue'),
    meta: {
      menu: 'CaseDashboard'
    }
  },
  // 成功的
  {
    path: '/cases2',
    name: 'CaseList2',
    component: () => import('@/pages/case2.0-list.vue')
  },
  {
    path: '/cases2/createcaselist',
    name: 'CreateCaseList2',
    component: () => import('../pages/create-case2.vue')
  },
  {
    path: '/cases2/createcase',
    name: 'CreateCaseList2',
    component: () => import('@/pages/case-new-bussiness.vue'),
    meta: {
      menu: 'CreateCaseList2'
    }
  },
  {
    path: '/quotes',
    name: 'QuotesList',
    component: () => import('@/pages/quotes-list.vue')
  },
  {
    path: '/globalQuotes/:search',
    name: 'QuotesListWithSearchval',
    component: () => import('@/pages/quotes-list-from-dashboard.vue'),
    meta: {
      menu: 'QuotesList'
    }
  },
  {
    path: '/quote/:id',
    name: 'QuoteDetail',
    component: () => import('@/pages/quote-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'QuoteDetailDetail',
        component: () => import('@/modules/Quote/views/detail.vue'),
        meta: {
          menu: 'QuotesList'
        }
      },
      {
        path: 'related',
        name: 'QuoteDetailRelated',
        component: () => import('@/modules/Quote/views/related.vue'),
        meta: {
          menu: 'QuotesList'
        }
      },
      {
        path: 'acordForm',
        name: 'QuoteAcordForm',
        component: () => import('@/modules/Quote/views/acordForm.vue'),
        meta: {
          menu: 'QuotesList'
        }
      },
      {
        path: 'source',
        name: 'QuoteDetailSource',
        component: () => import('@/modules/Quote/views/source.vue'),
        meta: {
          menu: 'QuotesList'
        }
      },
      {
        path: 'additional',
        name: 'QuoteDetailAdditional',
        component: () => import('@/modules/Quote/views/additional.vue'),
        meta: {
          menu: 'QuotesList'
        }
      }
    ]
  },
  {
    path: '/quote/policylist/:id',
    name: 'QuoteRelatedPoliciesList',
    component: () => import('@/pages/related-policies-list.vue'),
    meta: {
      menu: 'QuotesList'
    }
  },
  {
    path: '/vehicle/:id',
    name: 'VehicleDetail',
    component: () => import('@/pages/vehicle-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'VehicleDetailDetail',
        component: () => import('@/modules/Vehicle/views/detail.vue')
      },
      {
        path: 'additional',
        name: 'VehicleDetailAdditional',
        component: () => import('@/modules/Vehicle/views/additional.vue')
      }
    ]
  },
  {
    path: '/insureds',
    name: 'InsuredList',
    component: () => import('@/pages/insureds-list.vue')
  },
  {
    path: '/insured/:id',
    name: 'InsuredDetail',
    component: () => import('@/pages/insured-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'InsuredDetailDetail',
        component: () => import('@/modules/Insured/views/detail.vue')
      },
      {
        path: 'additional',
        name: 'InsuredDetailAdditional',
        component: () => import('@/modules/Insured/views/additional.vue')
      }
    ]
  },
  {
    path: '/properties',
    name: 'PropertyList',
    component: () => import('@/pages/properties-list.vue')
  },
  {
    path: '/property/:id',
    name: 'PropertyDetail',
    component: () => import('@/pages/property-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'PropertyDetailDetail',
        component: () => import('@/modules/Property/views/detail.vue')
      },
      {
        path: 'additional',
        name: 'PropertyDetailAdditional',
        component: () => import('@/modules/Property/views/additional.vue')
      }
    ]
  },
  {
    path: '/statementUploads',
    name: 'StatementUploadList',
    component: () => import('@/pages/statements-list.vue')
  },
  {
    path: '/statement/:id',
    name: 'StatementDetail',
    component: () => import('@/pages/statement-detail.vue'),
    meta: {
      menu: 'StatementUploadList'
    }
  },
  {
    path: '/generalAgents',
    name: 'GeneralAgentsList',
    component: () => import('@/pages/general-agents-list.vue')
  },
  {
    path: '/generalAgent/:id',
    name: 'GeneralAgentDetail',
    component: () => import('@/pages/general-agent-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'GeneralAgentDetailDetail',
        component: () => import('@/modules/GeneralAgent/views/detail.vue'),
        meta: {
          menu: 'GeneralAgentsList'
        }
      },
      {
        path: 'additional',
        name: 'GeneralAgentDetailAdditional',
        component: () => import('@/modules/GeneralAgent/views/additional.vue'),
        meta: {
          menu: 'GeneralAgentsList'
        }
      }
    ]
  },
  {
    path: '/agencies',
    name: 'AgenciesList',
    component: () => import('@/pages/agencies-list.vue')
  },
  {
    path: '/agency/:id',
    name: 'AgencyDetail',
    component: () => import('@/pages/agency-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'AgencyDetailDetail',
        component: () => import('@/modules/Agency/views/detail.vue'),
        meta: {
          menu: 'AgenciesList'
        }
      },
      {
        path: 'additional',
        name: 'AgencyDetailAdditional',
        component: () => import('@/modules/Agency/views/additional.vue'),
        meta: {
          menu: 'AgenciesList'
        }
      }
    ]
  },
  {
    path: '/books',
    name: 'BooksList',
    component: () => import('@/pages/books-list.vue')
  },
  {
    path: '/book/:id',
    name: 'BookDetail',
    component: () => import('@/pages/book-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'BookDetailDetail',
        component: () => import('@/modules/Book/views/detail.vue'),
        meta: {
          menu: 'BooksList'
        }
      },
      {
        path: 'additional',
        name: 'BookDetailAdditional',
        component: () => import('@/modules/Book/views/additional.vue'),
        meta: {
          menu: 'BooksList'
        }
      }
    ]
  },
  {
    path: '/phonelogs',
    name: 'PhoneLogs',
    component: () => import('@/pages/phone-log.vue')
  },
  {
    path: '/tasks',
    name: 'TaskList',
    component: () => import('@/pages/task-list.vue')
  },
  {
    path: '/task/:id',
    name: 'TaskDetail',
    component: () => import('@/pages/task-detail.vue'),
    meta: {
      menu: 'TaskList'
    }
  },
  {
    path: '/thirdParties',
    name: 'ThirdPartyList',
    component: () => import('@/pages/third-party-list.vue')
  },
  {
    path: '/thirdParty/:id',
    name: 'ThirdPartyDetail',
    component: () => import('@/pages/third-party-detail.vue'),
    children: [
      {
        path: 'detail',
        name: 'ThirdPartyDetailDetail',
        component: () => import('@/modules/ThirdParty/views/detail.vue'),
        meta: {
          menu: 'ThirdPartyList'
        }
      }
    ]
  },
  {
    path: '/caseReports',
    name: 'CaseReports',
    component: () => import('@/pages/case-reports.vue')
  },
  {
    path: '/fileUpload',
    name: 'OcrFileUpload',
    component: () => import('@/pages/ocr-file-upload.vue')
  },
  {
    path: '/fileUploadHistory',
    name: 'FileUploadHistory',
    component: () => import('@/pages/ocr-file-list.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(({ name }, from, next) => {
  if (localStorage.getItem(process.env.VUE_APP_JWT_NAME || 'VERGE_JWT_TOKEN')) {
    next()
  } else {
    if (name === 'SignIn') {
      next()
    } else {
      next({ name: 'SignIn' })
    }
  }
})

export default router
